export enum SystemSettingTypes {
  AdminTermsOfService = 1
}
